/**
 * Factory for dynamically creating Data Layers.
 */

import React from 'react';

import TileLayer from '../TileLayer';
import GeojsonLayer from '../GeojsonLayer';
import ImageLayer from '../ImageLayer';
import MarkerLayer from '../MarkerLayer';
import MarkerClusterLayer from '../MarkerClusterLayer';

const dataLayers = {
  tileOverlay: React.createFactory(TileLayer),
  geojsonOverlay: React.createFactory(GeojsonLayer),
  imageOverlay: React.createFactory(ImageLayer),
  markerOverlay: React.createFactory(MarkerLayer),
  markerClusterOverlay: React.createFactory(MarkerClusterLayer)
};

/**
 * Returns DataLayer React Component of the passed type.
 * @param  {String} type  DataLayer type (for example 'tileOverlay')
 * @param  {Object} props Properties that are passed to the new DataLayer
 * @return {ReactComponent}
 */
function getLayerByType(type, props) {
  if (typeof dataLayers[type] === 'undefined') {
    throw new Error(
      `You are trying to use an invalid data layer type.
      Valid types are ${Object.keys(dataLayers).join(',')}`);
  }
  return dataLayers[type]({ key: `DataLayer_${type}_${props.id}`, ...props });
}

export default {
  getLayerByType
};



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/Utils/Factory.js
 **/